import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function ZeroToLowMerchantYes({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (isError[name]) {
      setIsError((prev) => ({ ...prev, [name]: false }));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!primaryDetails.maya_transaction) {
      errors.maya_transaction = true;
    }
    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (validateForm()) {
      navigation.go("dcc-flyer");
    } else {
      toast.error("Please fill in all required fields.");
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  const reasons = [
    "HO restriction",
    "Issues with Maya terminal, specify concern",
    "Issues with Maya SQR, specify concern",
    "Issues with Maya Dynamic QR (DQR), specify concern",
    "merchant has an ongoing promo with competitor acquirer; specify promo mechanics",
    "display restrictions (clean store, etc.)",
    "close and pulled out",
    "other reasons, specify concern",
  ];

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">ZERO TO LOW MERCHANTS</h4>
              <p className="form-desc">Reason behind zero to low Maya transactions</p>
            </div>

            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">

                  {/* Reasons */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Reason behind zero to low Maya transactions
                      <span className="form-required">*</span>
                    </Form.Label>
                    <div className={`form-radio-group ${isError.maya_transaction ? "form-group-error" : ""}`}>
                      {reasons.map((reason, idx) => (
                        <div key={idx} className="form-radio-item">
                          <Form.Check
                            type="radio"
                            id={`reason_${idx}`}
                            name="maya_transaction"
                            value={reason}
                            checked={primaryDetails.maya_transaction === reason}
                            onChange={handleInputChange}
                            label={reason}
                            className="form-radio"
                          />
                        </div>
                      ))}
                    </div>
                    {isError.maya_transaction && (
                      <div className="form-error">Please select a reason.</div>
                    )}
                  </Form.Group>

                  {/* Additional details */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Specify concerns as to why merchant rarely or does not use Maya solutions
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="zero_to_low_details"
                      value={primaryDetails.zero_to_low_details || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      type="button"
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      type="button"
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                      Next →
                    </AppButton>
                  </div>

                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ZeroToLowMerchantYes;
